module.exports = {
  "previous": "Previous",
  "next": "Next",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Selected Date: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Selected Range: ".concat(args.dateRange);
  },
  "todayDate": function todayDate(args) {
    return "Today, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "Today, ".concat(args.date, " selected");
  },
  "dateSelected": function dateSelected(args) {
    return "".concat(args.date, " selected");
  },
  "startRangeSelectionPrompt": "Click to start selecting date range",
  "finishRangeSelectionPrompt": "Click to finish selecting date range",
  "minimumDate": "First available date",
  "maximumDate": "Last available date",
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " to ").concat(args.endDate);
  }
};